import React, { createContext, useCallback, useContext, useState } from 'react'

import ICidade from 'shared/modules/cidades/domain/entities/Cidade'

interface IFiltrosContextState {
  nomeOuCpf: string
  setNomeOuCpf: (nomeOuCpf: string) => void
  cte: string
  setCte: (cte: string) => void
  placa: string
  setPlaca: (nomeOuCpf: string) => void
  origemCompleta: ICidade
  setOrigemCompleta: (origemCompleta: ICidade) => void
  destinoCompleto: ICidade
  setDestinoCompleto: (destinoCompleto: ICidade) => void
  clearFilterLotes(): void
}

const FiltrosContext = createContext<IFiltrosContextState>(
  {} as IFiltrosContextState,
)

export function useFiltros(): IFiltrosContextState {
  const context = useContext(FiltrosContext)

  if (!context) {
    throw new Error('useFiltros must be used within an FiltrosProvider')
  }

  return context
}

export const FiltrosProvider: React.FC = ({ children }) => {
  const [destinoCompleto, setDestinoCompleto] = useState({} as ICidade)
  const [origemCompleta, setOrigemCompleta] = useState({} as ICidade)
  const [nomeOuCpf, setNomeOuCpf] = useState('')
  const [cte, setCte] = useState('')
  const [placa, setPlaca] = useState('')

  const setFiltroDestinoCompleto = useCallback((value: ICidade) => {
    setDestinoCompleto(value)
  }, [])

  const setFiltroOrigemCompleta = useCallback((value: ICidade) => {
    setOrigemCompleta(value)
  }, [])

  const clearFilterLotes = useCallback(() => {
    setDestinoCompleto(null)
    setOrigemCompleta(null)
    setNomeOuCpf('')
    setCte('')
    setPlaca('')
  }, [])

  return (
    <FiltrosContext.Provider
      value={{
        origemCompleta,
        setOrigemCompleta: setFiltroOrigemCompleta,
        destinoCompleto,
        setDestinoCompleto: setFiltroDestinoCompleto,
        clearFilterLotes,
        nomeOuCpf,
        placa,
        setNomeOuCpf,
        setPlaca,
        cte,
        setCte,
      }}
    >
      {children}
    </FiltrosContext.Provider>
  )
}
